import script from "./BecomeAMemberSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./BecomeAMemberSection.vue?vue&type=script&lang=ts&setup=true"

import "./BecomeAMemberSection.vue?vue&type=style&index=0&id=2570c783&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2570c783"]])

export default __exports__